import { createSlice } from '@reduxjs/toolkit';
import { getLegacyRegiones } from '../legacy/thunk.js';

export const initialState = {
    legacyRegiones: [],
    loading: false,
    error: {},
};

const legacyRegionesSlice = createSlice({
    name: 'legacyRegiones',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyRegiones.fulfilled, (state, action) => {
            state.legacyRegiones = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyRegiones.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyRegiones.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyRegionesSlice.reducer;